export const taxRate = 0.0825

const prodTaxRateId = "txr_1IZr4pDmt915koXeacD6sGeI"
const testTaxRateId = "txr_1IcSPEDmt915koXeQi3PxK9c"
export const taxRateId =
  process.env.NODE_ENV === "production" ? prodTaxRateId : testTaxRateId
